// extracted by mini-css-extract-plugin
export default {"root":"fLrbvZ1F"};